import { createSlice } from '@reduxjs/toolkit'
import { REHYDRATE } from 'redux-persist'

const initialState = {
  processed: false,
  lastVerifyDate: '1970-01-01T00:00:00.000Z',
  stopRemind: false,
  identityInputModal: { open: false, identity: '' },
  showVerifyEntrance: false,
  checkVerificationInLsApp: false,
}

export const syDealCustomerVerifySlice = createSlice({
  name: 'syDealCustomerVerify',
  initialState: initialState,
  reducers: {
    syDealCustomerVerificationProcessed: (state, action) => {
      const date = action.payload
      state.lastVerifyDate = date
      state.processed = true
    },
    stopRemindingSyDealCustomerVerify: (state, action) => {
      state.stopRemind = true
    },

    openSyDealCustomerIdentityInputModal: (state, action) => {
      state.identityInputModal = { open: true, identity: '' }
    },
    closeSyDealCustomerIdentityInputModal: (state, action) => {
      state.identityInputModal = { open: false, identity: '' }
    },
    setSyDealCustomerIdentity: (state, action) => {
      state.identityInputModal.identity = action.payload
    },
    showSinyiCustomerVerifyEntrance: (state, action) => {
      state.showVerifyEntrance = action.payload
    },
    setCheckVerificationInLsApp: (state, action) => {
      state.checkVerificationInLsApp = action.payload
    },
    clearSyDealCustomerVerify: (state, action) => {
      return { ...initialState }
    },
  },

  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action) => {
      return { ...state, ...action.payload?.syDealCustomerVerify }
    })
  },
})

export const selectSyDealCustomerVerifyData = (state) =>
  state.syDealCustomerVerify
export const selectSyDealCustomerIdentityInputModal = (state) =>
  state.syDealCustomerVerify.identityInputModal
export const selectShowSinyiCustomerVerifyEntrance = (state) =>
  state.syDealCustomerVerify.showVerifyEntrance

export const {
  syDealCustomerVerificationProcessed,
  stopRemindingSyDealCustomerVerify,
  openSyDealCustomerIdentityInputModal,
  closeSyDealCustomerIdentityInputModal,
  setSyDealCustomerIdentity,
  showSinyiCustomerVerifyEntrance,
  setCheckVerificationInLsApp,
  clearSyDealCustomerVerify,
} = syDealCustomerVerifySlice.actions

export default syDealCustomerVerifySlice.reducer
